module.exports = __webpack_public_path__ + "img/dress-detail-back.2e928503.jpg";